'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react-is.production.min.js');
} else {
  module.exports = require('./cjs/react-is.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router/node_modules/hoist-non-react-statics/node_modules/react-is/index.js
// module id = 1158
// module chunks = 0